import React from "react";
import { path } from "ramda";
import { fixedNumber } from "utilities/commonUtils";
import { Cell, Header } from "./commonElements";
import i18n from "../../../../i18n.js";

const handleCellConstruct = row => {
    const bmi = path(["value"], row);
    const value = bmi && fixedNumber(bmi);
    return <Cell row={row} value={value} />;
};

export const bmiDef = iconTypes => ({
    minWidth: 92,
    accessor: "bmi",
    Cell: handleCellConstruct,
    Header: () => <Header label={i18n.t("words.body_mass_index")} iconType={iconTypes.bmi} />
});
